export var getButtonRoleProps = function() {
    // Mostly cribbed from https://www.w3.org/TR/wai-aria-practices/examples/button/js/button.js
    var onKeyDown = function(evt) {
        if (evt.key === " ") {
            evt.preventDefault();
        } else if (evt.key === "Enter") {
            evt.preventDefault();
            evt.currentTarget.click();
        }
    };
    var onKeyUp = function(evt) {
        if (evt.key === " ") {
            evt.preventDefault();
            evt.currentTarget.click();
        }
    };
    return {
        role: "button",
        tabIndex: 0,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
};
